import React from 'react';
import type ContactAdministratorPageType from '@atlassian/jira-admin-pages-contact-administrator/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyContactAdministratorPage = lazyForPaint<typeof ContactAdministratorPageType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-jira-admin-pages-contact-administrator", jiraSpaEntry: "async-jira-admin-pages-contact-administrator" */ '@atlassian/jira-admin-pages-contact-administrator'
		),
	),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyContactAdministratorPage}
		pageId="jira-admin-pages-contact-administrator"
		shouldShowSpinner
	/>
);
